module.exports = __webpack_public_path__ + "static/media/YF106_3.c7141917.jpg";